import Image from 'next/image'
import { ComponentPropsWithoutRef } from 'react'
import { cn } from '~shared/utils/cn'

export interface GirlBannerProps extends ComponentPropsWithoutRef<'div'> {}

export const GirlBanner = ({ className, ...rest }: GirlBannerProps) => {
  return (
    <div className={cn('relative select-none', className)} {...rest}>
      <div className=''>
        <Image
          src='/assets/imgs/main-page/results-section-person.png'
          alt='Person'
          width={967}
          height={1138}
          className='w-[174px] md:w-[206px] xl:w-[331px] 2xl:w-[344px]'
          draggable={false}
        />
      </div>
      <Image
        src='/assets/imgs/main-page/results-section-comment.png'
        alt='Adornment'
        width={210}
        height={210}
        className={cn(
          'w-[60px] md:w-[82px] xl:w-[105px] 2xl:w-[125px] absolute',
          'bottom-[80px] left-[-35px]',
          'md:bottom-[47px] md:left-[-32px]',
          'lg:bottom-[33px] lg:left-[-32px]',
          'xl:bottom-[174px] xl:left-[-50px]',
          '2xl:bottom-[72px] 2xl:left-[-53px]'
        )}
        draggable={false}
      />
      <p
        className={cn(
          'absolute hidden xl:flex items-center justify-center rounded-[50px] px-[16px] bg-tertiary text-[16px] leading-[1.2] text-primary h-[37px]',
          'right-0 bottom-[45px] 2xl:bottom-[50px]'
        )}>
        в&nbsp;сети
      </p>
    </div>
  )
}

interface LeftCardProps extends ComponentPropsWithoutRef<'li'> {
  title: string
  description: string
}

const LeftCard = ({
  title,
  description,
  className,
  ...rest
}: LeftCardProps) => {
  return (
    <li
      className={cn(
        'bg-primary text-tertiary flex flex-col gap-[8px] justify-between p-card-inner-indent rounded-[24px]',
        className
      )}
      {...rest}>
      <p
        className={cn(
          'text-[30px] md:text-[50px] lg:text-[64px] 2xl:text-[80px] leading-[1] tracking-[-0.04em]',
          ''
        )}>
        {title}
      </p>
      <p className={cn('text-[14px] md:text-[16px] leading-[1.1]', '')}>
        {description}
      </p>
    </li>
  )
}

interface RightCardProps extends ComponentPropsWithoutRef<'div'> {}

const RightCard = ({ className, ...rest }: RightCardProps) => {
  return (
    <div
      className={cn(
        'relative bg-accent flex flex-col justify-between text-primary rounded-[24px] p-[24px]',
        'p-card-inner-indent pr-[200px] md:pr-[24px] xl:pr-[355px] 2xl:pr-[404px]',
        'h-[250px] md:h-auto',
        className
      )}
      {...rest}>
      <div>
        <p className='text-[16px] md:text-[20px] lg:text-[32px] font-medium leading-[1]'>
          Это&nbsp;Анна&nbsp;Бушкарева
        </p>
        <p className='mt-[8px] lg:mt-[16px] text-[14px] md:text-[16px] leading-[1]'>
          руководитель центра карьеры MITM
        </p>
      </div>
      <div className='self-end md:self-center lg:self-end absolute md:static xl:absolute bottom-[16px] right-[16px] xl:bottom-[24px] xl:right-[24px] 2xl:bottom-[36px] 2xl:right-[60px]'>
        <GirlBanner className='' />
      </div>
      <p className='text-[14px] md:text-[16px] lg:text-[24px] font-medium leading-[1] 2xl:max-w-[260px]'>
        Отвечает за то, чтобы студенты нашли новую работу после обучения у нас
      </p>
    </div>
  )
}

export interface ResultsSectionProps extends ComponentPropsWithoutRef<'div'> {}

export const ResultsSection = (props: ResultsSectionProps) => {
  const { className, ...rest } = props
  return (
    <section className={cn('container container-slim', className)} {...rest}>
      <div
        className={cn(
          'bg-secondary rounded-[24px] md:rounded-[40px] lg:rounded-[64px]',
          'p-[16px] md:p-[24px] lg:p-[40px] xl:p-[60px]'
        )}>
        <h2 className='typo-section-heading'>
          Помогаем устроиться на&nbsp;работу и&nbsp;гарантируем результат
        </h2>
        <div
          className={cn(
            'flex flex-col md:flex-row gap-[10px] md:gap-[16px] mt-[60px] min-h-[446px]',
            'mt-[16px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px]'
          )}>
          <ul
            className={cn(
              'grid grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-[10px] md:gap-[8px] lg:gap-[16px]'
            )}>
            <LeftCard
              title='72 000 ₽'
              description='Средняя зарплата наших выпускников после обучения'
              className='lg:col-span-2'
            />
            <LeftCard
              title='95%'
              description='выпускников выходят на работу в течении 4 месяцев'
            />
            <LeftCard
              title='2-3'
              description='приглашения на работу получает наш выускник'
              className='col-span-2 md:col-span-1 '
            />
          </ul>
          <RightCard className='shrink-0 md:basis-1/2 xl:basis-[660px] 2xl:basis-[830px]' />
        </div>
      </div>
    </section>
  )
}
